(function(){
	angular
		.module('historicoCabecalhoModule', []);
})();